import React, { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { toast } from 'sonner';

export const RefuseReasonDialog = ({ open, onOpenChange, onConfirm, reasons = [] }) => {
    const [motif, setMotif] = useState(reasons[0] || '');
    const [notes, setNotes] = useState('');

    useEffect(() => {
        if (open) {
            setMotif(reasons[0] || '');
            setNotes('');
        }
    }, [open, reasons]);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent data-testid="refuse-reason-dialog">
                <DialogHeader>
                    <DialogTitle>Motif du refus</DialogTitle>
                </DialogHeader>
                <div className="space-y-3">
                    <Label className="field-label">Raison</Label>
                    <select
                        className="w-full h-10 rounded-sm border border-[#E4E4E7] px-3 text-sm"
                        value={motif}
                        onChange={(e) => setMotif(e.target.value)}
                        data-testid="refuse-reason-select"
                    >
                        {reasons.map((r) => <option key={r} value={r}>{r}</option>)}
                    </select>
                    <Label className="field-label">Notes complémentaires (optionnel)</Label>
                    <Textarea
                        rows={3}
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        className="rounded-sm"
                        placeholder="Précisions..."
                        data-testid="refuse-reason-notes"
                    />
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-sm">Annuler</Button>
                    <Button
                        onClick={() => {
                            if (!motif) return toast.error('Sélectionnez un motif');
                            onConfirm({ raison_refus: motif, raison_refus_notes: notes });
                        }}
                        className="bg-[#E85A24] hover:bg-[#CC4D1C] text-white rounded-sm"
                        data-testid="refuse-reason-confirm"
                    >
                        Confirmer le refus
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
